<template>
    <div class="pageContent">
        <bindDetails @getBind="getBind" @getLater="getLater" />
    </div>
</template>
<script>
import bindDetails from "@/components/checkInfo/index.vue";
import { bind } from '@/api/login';
import Storage from "@/tools/storage"
export default {
  name: "checkInfo",
  components: { bindDetails },
  data() {
    return {};
  },
  methods:{
    async getBind(params){
      let res = await bind(params)
      if(res){
        this.$router.push({path:'/filmQuery'})
        Storage.set('bind',1)
      }
    },
    getLater(){
      this.$router.push({ path: "/filmQuery" });
      Storage.set('bind',2)
    }
  }
};
</script>
<style lang="scss" scoped>
</style>


